<template>
  <el-row id="app">
    <el-col :span="16">
      <el-row>
          <el-col :span="24">
            <component :is="ChinaMap" :mainPageData="mainPageData"></component>
          </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <component :is="LastYearOutTrade" :mainPageData="mainPageData"></component>
        </el-col>
        <el-col :span="12">
          <component :is="LastYearInTrade" :mainPageData="mainPageData"></component>
        </el-col>
      </el-row>
      
    </el-col>
    <el-col :span="8">
      <el-row>
        <el-col :span="24">
          <component :is="LastYearInfo"
            :mainPageData="mainPageData"
          ></component>
        </el-col>
      </el-row>
      <el-row>
          <el-col :span="24">
            <component :is="LastYearCountryTrade" :mainPageData="mainPageData"></component>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="24">
            <component :is="YearsCountryTrade" :mainPageData="mainPageData"></component>
          </el-col>
      </el-row>
    </el-col>


      <!-- <el-col :span="8">
        <el-row>
          <el-col :span="24"><last-year-country-trade /></el-col>
        </el-row>
        <el-row>
          <el-col :span="24"><last-year-in-trade /></el-col>
        </el-row>
        <el-row>
          <el-col :span="24"><last-year-out-trade /></el-col>
        </el-row>
        
      </el-col>
      <el-col :span="8">
        <el-row>
          <el-col :span="24"><transport-in /> </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"><main-good-trade /></el-col>
        </el-row>
        <el-row>
          <el-col :span="24"><trade-term-in /></el-col>
        </el-row>
        
      </el-col>
      <el-col :span="8">
        <el-row>
          <el-col :span="24"><transport-out /></el-col>
        </el-row>
        <el-row>
           <el-col :span="24"> <years-country-trade /></el-col>
        </el-row>
        <el-row>
           <el-col :span="24"> <trade-term-out/></el-col>
        </el-row>
      </el-col> -->
    </el-row>
</template>

<script>
import LastYearCountryTrade from '@/components/LastYearCountryTrade'
import ChinaMap from '@/components/ChinaMap'
import OtherMap from '@/components/OtherMap'
import LastYearOutTrade from '@/components/LastYearOutTrade'
import LastYearInTrade from '@/components/LastYearInTrade'
import MainGoodTrade from '@/components/MainGoodTrade'
import YearsCountryTrade from '@/components/YearsCountryTrade'
import TransportIn from '@/components/TransportIn'
import TransportOut from '@/components/TransportOut'
import TradeTermIn from '@/components/TradeTermIn'
import TradeTermOut from '@/components/TradeTermOut'
import LastYearInfo from '@/components/LastYearInfo'


export default {
  name: 'App',
  components: { LastYearCountryTrade, ChinaMap, OtherMap, LastYearOutTrade, 
  LastYearInTrade, MainGoodTrade, YearsCountryTrade, TransportIn, TransportOut,
  TradeTermIn, TradeTermOut, LastYearInfo
  },
  data () {
    return {
      mainPageData: {},
      LastYearCountryTrade: '',
      YearsCountryTrade: '',
      ChinaMap: '',
      LastYearOutTrade: '',
      LastYearInTrade: '',
      LastYearInfo: '',
    }
  },
  mounted () {
    this.getMainPage();
  },
  methods: {
    getMainPage() {
      this.$ajax({
        method: 'GET',
        url: '/cee/rest/web/mainPage'
      }).then(resp => {
        this.mainPageData = resp.data;
        this.LastYearInfo = 'LastYearInfo';
        this.LastYearCountryTrade = 'LastYearCountryTrade';
        this.YearsCountryTrade = 'YearsCountryTrade';
        this.LastYearOutTrade = 'LastYearOutTrade';
        this.LastYearInTrade = 'LastYearInTrade';
        this.ChinaMap = 'ChinaMap';
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue